module.exports = __webpack_public_path__ + "static/media/56513578-ea68-4885-9d7b-d3623999c630.01294c8e.JPG";